import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s talk about your project</h2>
                        </div>
                        <p>Ready to turn your app idea into a reality? TekRevol is here to make it happen! Whether you're in the USA, Canada, GCC, or the UK, our team is geared up to bring your vision to life. Our straightforward approach starts with a conversation about your project. No jargon, no complicated terms – just a friendly chat to understand what you need. We're all ears, ready to discuss your goals. All you need to do is give that “Get in Touch” button a cheeky little click!.</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;